import { render, staticRenderFns } from "./MenuLateralUnidade.vue?vue&type=template&id=cd8c6864&"
import script from "./MenuLateralUnidade.vue?vue&type=script&lang=js&"
export * from "./MenuLateralUnidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports